// ADO work item types available in the Studio-Custom-process. Auto mode always
// files a Bug; the manual Bugsnap report and the admin default both use this
// list and default to Bug so behavior is unchanged unless another type is picked.
export const WORK_ITEM_TYPE_OPTIONS = [
  'Bug',
  'Epic',
  'Feature',
  'Initiatives',
  'Issue',
  'Task',
  'Test Case',
  'User Story',
]

// Jira's default issue types. Jira issue-type schemes are per-project, so this is a
// starting list rather than a guarantee — the backend retries a create with type Bug
// if the configured type is not in the project's scheme.
export const JIRA_ISSUE_TYPE_OPTIONS = ['Bug', 'Task', 'Story', 'Epic', 'Sub-task']
